// extracted by mini-css-extract-plugin
export default {"box":"LoginForm_box__UUn1q","container":"LoginForm_container__ZVUJ-","form":"LoginForm_form__j-y1h","button":"LoginForm_button__hHec2","google":"LoginForm_google__GEKPr"};